import { FC, useState } from 'react';
import dynamic from 'next/dynamic';
import { Tabs } from '@zoopla-eng/zds/tabs';
import { triggerTracking } from '@zoopla/tracking';
import RegisterSection from '../section/Register';
import { SocialAuthProps } from '../AuthModal.types';
import { Box } from '@zoopla-eng/zds/box';

const SignInSection = dynamic(() => import('../section/SignIn'), {
    ssr: false
});

const signInTitleTn = 'Sign In';
const registerTitleTn = 'Register';

export const RegTabs: FC<React.PropsWithChildren<SocialAuthProps>> = (
    props
) => {
    const {
        initialMode = 'register',
        actionAfterAuth,
        resetActionAfterAuth = () => null,
        isShowing,
        onSocialAuth,
        close,
        setCurrentStep
    } = props;

    const [selectedTab, setSelectedTab] = useState(initialMode);

    return (
        <Tabs
            label="Register or sign in"
            value={selectedTab}
            tabs={[
                {
                    label: registerTitleTn,
                    value: 'register',
                    component: (
                        <Box pt="S400">
                            <RegisterSection
                                {...props}
                                close={close}
                                actionAfterAuth={actionAfterAuth}
                                resetActionAfterAuth={resetActionAfterAuth}
                                onSocialAuth={onSocialAuth}
                                setCurrentStep={setCurrentStep}
                            />
                        </Box>
                    )
                },
                {
                    label: signInTitleTn,
                    value: 'sign-in',
                    component: (
                        <Box pt="S400">
                            <SignInSection
                                {...props}
                                isShowing={isShowing}
                                close={close}
                                actionAfterAuth={actionAfterAuth}
                                resetActionAfterAuth={resetActionAfterAuth}
                                onSocialAuth={onSocialAuth}
                                setCurrentStep={setCurrentStep}
                            />
                        </Box>
                    )
                }
            ]}
            alignment={{
                default: 'fill',
                bpL100: 'left'
            }}
            onValueChange={(newTabToShow) => {
                setSelectedTab(newTabToShow);

                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'registration',
                    eventAction:
                        newTabToShow === 'sign-in'
                            ? 'click_to_signin'
                            : 'click_to_register',
                    eventLabel: actionAfterAuth?.eventLabel
                });
            }}
        />
    );
};
